module.exports = __webpack_public_path__ + "static/media/logo_dark.5c4fbc33.svg";